import React from 'react';
import { Divider } from 'rsuite';
import { Eshop } from '../../../api/eshop/eshop';
import EshopSetupDetail, { Input, Labels } from '../EshopSetupDetail';
import EshopSetupCrossDock from '../EshopSetupCrossDock';
import EshopSetupPricing from '../EshopSetupPricing';
import EshopSetupPartnerSalesEntity from '../EshopSetupPartnerSalesEntity';

interface Props {
  eshop: Eshop;
  onUpdate: () => void
}

const labels: Labels = {
  clientKey: 'ID',
  clientSecret: 'Client ID',
  stockThreshold: 'Stock threshold',
  expeditionDays: 'Expedition days',
  fixedFee: 'Fixed fee',
  dynamicBranchId: '',
  substitutedPhoneNumber: 'Substitute for an empty phone number',
  packetaId: '',
  packetaApiKey: '',
  invoiceRequired: '',
  creditNoteRequired: '',
};

const inputs: Input[] = [
  Input.SYNCHRONIZATION,
  Input.CLIENT_KEY,
  Input.CLIENT_SECRET,
  Input.STOCK_THRESHOLD,
  Input.EXPEDITION_DAYS,
  Input.FIXED_FEE,
  Input.SUBSTITUTED_PHONE_NUMBER,
];

export default function EshopSetupMall({ eshop, onUpdate }: Props) {
  return (
    <>
      <EshopSetupDetail
        eshop={eshop}
        labels={labels}
        inputs={inputs}
        onSuccessfulSave={onUpdate}
      />
      <Divider>Cross dock</Divider>
      <EshopSetupCrossDock eshop={eshop} />
      <Divider>Pricing</Divider>
      <EshopSetupPricing eshop={eshop} />
      <Divider>Partner&apos;s business entity</Divider>
      <EshopSetupPartnerSalesEntity eshop={eshop} />
    </>
  );
}
